module.exports = __webpack_public_path__ + "img/selected4-min.d72ca1af.png";